export function HealthPage() {
  const health = {
    status: 'ok',
    portal: 'admin',
    timestamp: new Date().toISOString(),
  };

  return (
    <pre className="p-4 text-sm font-mono text-text">
      {JSON.stringify(health, null, 2)}
    </pre>
  );
}
